
export default function NumberCard({ title, value, icon, className='' }) {
	return (
		<div className={`${className} relative border rounded-lg p-4 text-gray-600 font-[Arial]`}>
			<div className="text-sm font-thin">
				{title}
			</div>
			<div className="text-2xl font-bold">
				{value}
			</div>
			<div className="absolute top-2 right-2">
				{icon}
			</div>
		</div>
	);
}